import React, { useEffect, useMemo, useRef, useState } from "react";
import { Platform, StyleSheet, Text, View } from "react-native";

export const GOOGLE_FONT_OPTIONS = [
	{ family: "Inter", category: "Sans Serif" },
	{ family: "Roboto", category: "Sans Serif" },
	{ family: "Open Sans", category: "Sans Serif" },
	{ family: "Poppins", category: "Sans Serif" },
	{ family: "Montserrat", category: "Sans Serif" },
	{ family: "Raleway", category: "Sans Serif" },
	{ family: "Nunito", category: "Sans Serif" },
	{ family: "Lato", category: "Sans Serif" },
	{ family: "Source Sans 3", category: "Sans Serif" },
	{ family: "Work Sans", category: "Sans Serif" },
	{ family: "Barlow", category: "Sans Serif" },
	{ family: "Quicksand", category: "Sans Serif" },
	{ family: "Manrope", category: "Sans Serif" },
	{ family: "Urbanist", category: "Sans Serif" },
	{ family: "Figtree", category: "Sans Serif" },
	{ family: "Mulish", category: "Sans Serif" },
	{ family: "Plus Jakarta Sans", category: "Sans Serif" },
	{ family: "Outfit", category: "Sans Serif" },
	{ family: "DM Sans", category: "Sans Serif" },
	{ family: "Public Sans", category: "Sans Serif" },
	{ family: "Space Grotesk", category: "Sans Serif" },
	{ family: "Instrument Sans", category: "Sans Serif" },
	{ family: "Sora", category: "Sans Serif" },
	{ family: "Lexend", category: "Sans Serif" },
	{ family: "Playfair Display", category: "Serif" },
	{ family: "Cormorant Garamond", category: "Serif" },
	{ family: "Merriweather", category: "Serif" },
	{ family: "Libre Baskerville", category: "Serif" },
	{ family: "Lora", category: "Serif" },
	{ family: "Bodoni Moda", category: "Serif" },
	{ family: "Crimson Text", category: "Serif" },
	{ family: "EB Garamond", category: "Serif" },
	{ family: "Spectral", category: "Serif" },
	{ family: "Prata", category: "Serif" },
	{ family: "Old Standard TT", category: "Serif" },
	{ family: "Fraunces", category: "Serif" },
	{ family: "Cardo", category: "Serif" },
	{ family: "Alegreya", category: "Serif" },
	{ family: "Bitter", category: "Serif" },
	{ family: "Vollkorn", category: "Serif" },
	{ family: "Marcellus", category: "Serif" },
	{ family: "Cormorant", category: "Serif" },
	{ family: "Bebas Neue", category: "Display" },
	{ family: "Oswald", category: "Display" },
	{ family: "Anton", category: "Display" },
	{ family: "Abril Fatface", category: "Display" },
	{ family: "Cinzel", category: "Display" },
	{ family: "DM Serif Display", category: "Display" },
	{ family: "Righteous", category: "Display" },
	{ family: "Alfa Slab One", category: "Display" },
	{ family: "Bungee", category: "Display" },
	{ family: "Monoton", category: "Display" },
	{ family: "Fugaz One", category: "Display" },
	{ family: "Shrikhand", category: "Display" },
	{ family: "Yeseva One", category: "Display" },
	{ family: "Unbounded", category: "Display" },
	{ family: "Bricolage Grotesque", category: "Display" },
	{ family: "Black Ops One", category: "Display" },
	{ family: "Luckiest Guy", category: "Display" },
	{ family: "Fredoka", category: "Display" },
	{ family: "Paytone One", category: "Display" },
	{ family: "Ultra", category: "Display" },
	{ family: "Limelight", category: "Display" },
	{ family: "Notable", category: "Display" },
	{ family: "Pacifico", category: "Cursive" },
	{ family: "Great Vibes", category: "Cursive" },
	{ family: "Dancing Script", category: "Cursive" },
	{ family: "Satisfy", category: "Cursive" },
	{ family: "Allura", category: "Cursive" },
	{ family: "Sacramento", category: "Cursive" },
	{ family: "Parisienne", category: "Cursive" },
	{ family: "Alex Brush", category: "Cursive" },
	{ family: "Tangerine", category: "Cursive" },
	{ family: "Cookie", category: "Cursive" },
	{ family: "Courgette", category: "Cursive" },
	{ family: "Kaushan Script", category: "Cursive" },
	{ family: "Lobster", category: "Cursive" },
	{ family: "Lobster Two", category: "Cursive" },
	{ family: "Yellowtail", category: "Cursive" },
	{ family: "Marck Script", category: "Cursive" },
	{ family: "Petit Formal Script", category: "Cursive" },
	{ family: "Rouge Script", category: "Cursive" },
	{ family: "Qwigley", category: "Cursive" },
	{ family: "Caveat", category: "Handwritten" },
	{ family: "Shadows Into Light", category: "Handwritten" },
	{ family: "Patrick Hand", category: "Handwritten" },
	{ family: "Gloria Hallelujah", category: "Handwritten" },
	{ family: "Permanent Marker", category: "Handwritten" },
	{ family: "Indie Flower", category: "Handwritten" },
	{ family: "Amatic SC", category: "Handwritten" },
	{ family: "Architects Daughter", category: "Handwritten" },
	{ family: "Handlee", category: "Handwritten" },
	{ family: "Kalam", category: "Handwritten" },
	{ family: "Rock Salt", category: "Handwritten" },
	{ family: "Covered By Your Grace", category: "Handwritten" },
	{ family: "Homemade Apple", category: "Handwritten" },
	{ family: "Schoolbell", category: "Handwritten" },
	{ family: "Reenie Beanie", category: "Handwritten" },
	{ family: "Gochi Hand", category: "Handwritten" },
	{ family: "Just Another Hand", category: "Handwritten" },
	{ family: "Coming Soon", category: "Handwritten" },
	{ family: "Nanum Pen Script", category: "Handwritten" },
];

const GOOGLE_FONT_FAMILIES = new Set(GOOGLE_FONT_OPTIONS.map((font) => font.family));
const loadedFonts = new Set();

export const ensureGoogleFontLoaded = (fontFamily) => {
	if (Platform.OS !== "web" || !fontFamily || !GOOGLE_FONT_FAMILIES.has(fontFamily) || loadedFonts.has(fontFamily)) return;
	const safeId = `google-font-${fontFamily.replace(/[^a-z0-9]/gi, "-").toLowerCase()}`;
	if (document.getElementById(safeId)) {
		loadedFonts.add(fontFamily);
		return;
	}

	const link = document.createElement("link");
	link.id = safeId;
	link.rel = "stylesheet";
	link.href = `https://fonts.googleapis.com/css2?family=${fontFamily.replace(/ /g, "+")}&display=swap`;
	document.head.appendChild(link);
	loadedFonts.add(fontFamily);
};

export const getFontFamilyCss = (fontFamily) => {
	if (!fontFamily) return "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";
	if (fontFamily.includes(",") || fontFamily.includes("'") || fontFamily.includes('"')) return fontFamily;
	return `'${fontFamily}', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif`;
};

export const TEXT_ANIMATIONS = [
	{ value: "none", label: "None" },
	{ value: "fade", label: "Fade" },
	{ value: "fade-scale", label: "Fade + Scale" },
	{ value: "slide-up", label: "Slide Up" },
	{ value: "slide-down", label: "Slide Down" },
	{ value: "slide-left", label: "Slide Left" },
	{ value: "slide-right", label: "Slide Right" },
	{ value: "pop", label: "Pop" },
	{ value: "bounce", label: "Bounce" },
	{ value: "type", label: "Type/Reveal" },
];

export const ECARD_CANONICAL_WIDTH = 1080;
export const ECARD_CANONICAL_HEIGHT = 1080;
export const ECARD_CANONICAL_CANVAS = {
	width: ECARD_CANONICAL_WIDTH,
	height: ECARD_CANONICAL_HEIGHT,
};

export const ECARD_MEDIA_TYPES = {
	VIDEO: "video",
	GIF: "gif",
};

export const getECardMediaType = (card = {}) => {
	const explicitType = String(card.mediaType || card.eCardMediaType || "").toLowerCase();
	if (explicitType === ECARD_MEDIA_TYPES.GIF || explicitType === "image/gif") return ECARD_MEDIA_TYPES.GIF;
	if (explicitType === ECARD_MEDIA_TYPES.VIDEO || explicitType === "mp4" || explicitType.startsWith("video/")) return ECARD_MEDIA_TYPES.VIDEO;

	const assetType = String(card.videoAssetType || card.assetType || card.eCardAssetType || "").toLowerCase();
	if (assetType === "image/gif") return ECARD_MEDIA_TYPES.GIF;
	if (assetType.startsWith("video/")) return ECARD_MEDIA_TYPES.VIDEO;

	const assetUrl = String(card.videoAssetUrl || card.assetUrl || card.animatedECardUrl || card.eCardAssetUrl || card.emailGifUrl || card.gifAssetUrl || card.emailGifPreviewUrl || "").toLowerCase().split("?")[0];
	if (assetUrl.endsWith(".gif")) return ECARD_MEDIA_TYPES.GIF;
	if (assetUrl.endsWith(".mp4")) return ECARD_MEDIA_TYPES.VIDEO;

	return ECARD_MEDIA_TYPES.VIDEO;
};

export const isGifECardMedia = (card = {}) => getECardMediaType(card) === ECARD_MEDIA_TYPES.GIF;

export const getECardAssetType = (card = {}) => {
	const assetType = String(card.videoAssetType || card.assetType || card.eCardAssetType || "").trim();
	if (assetType) return assetType;
	return isGifECardMedia(card) ? "image/gif" : "video/mp4";
};

export const getECardPlaybackAssetUrl = (card = {}) => (
	card.videoAssetUrl ||
	card.assetUrl ||
	card.animatedECardUrl ||
	card.eCardAssetUrl ||
	card.emailGifUrl ||
	card.gifAssetUrl ||
	card.emailGifPreviewUrl ||
	""
);

export const getECardEmailGifUrl = (card = {}) => (
	card.emailGifUrl ||
	card.gifAssetUrl ||
	card.emailGifPreviewUrl ||
	(isGifECardMedia(card) ? getECardPlaybackAssetUrl(card) : "") ||
	""
);

const LEGACY_DESIGN_WIDTH = 380;
const LEGACY_TO_CANONICAL_SCALE = ECARD_CANONICAL_WIDTH / LEGACY_DESIGN_WIDTH;
const LEGACY_PERCENT_MAX = 100;
const DEFAULT_TEXT_SHADOW_OFFSET_Y = 2 * LEGACY_TO_CANONICAL_SCALE;
const DEFAULT_SLIDE_Y_DISTANCE = 18 * LEGACY_TO_CANONICAL_SCALE;
const DEFAULT_SLIDE_X_DISTANCE = 22 * LEGACY_TO_CANONICAL_SCALE;
const DEFAULT_BOUNCE_DISTANCE = 10 * LEGACY_TO_CANONICAL_SCALE;
const DEFAULT_ANIMATION_DURATION = 0.55;

const LEGACY_DEFAULT_LAYER = {
	x: 50,
	y: 50,
	width: 78,
	fontSize: 32,
	letterSpacing: 0,
	textShadowBlur: 8,
	strokeWidth: 0,
	animationStartX: 50,
	animationStartY: 50,
	animationEndX: 50,
	animationEndY: 50,
};

const DEFAULT_LAYER = {
	id: "layer-1",
	name: "Text Layer 1",
	text: "CONGRATULATIONS!",
	allowUserPersonalization: false,
	x: ECARD_CANONICAL_WIDTH / 2,
	y: ECARD_CANONICAL_HEIGHT / 2,
	width: ECARD_CANONICAL_WIDTH * 0.78,
	textAlign: "center",
	fontFamily: "Inter",
	fontSize: 32 * LEGACY_TO_CANONICAL_SCALE,
	fontWeight: "800",
	color: "#ffffff",
	lineHeight: 1.1,
	letterSpacing: 0,
	textShadowEnabled: true,
	textShadowColor: "rgba(0, 0, 0, 0.45)",
	textShadowBlur: 8 * LEGACY_TO_CANONICAL_SCALE,
	strokeColor: "rgba(0, 0, 0, 0)",
	strokeWidth: 0,
	startTime: 0,
	endTime: 6,
	endTimeEnabled: false,
	entranceAnimation: "fade-scale",
	exitAnimation: "fade",
	animationPositionEnabled: false,
	animationDuration: DEFAULT_ANIMATION_DURATION,
	animationStartX: ECARD_CANONICAL_WIDTH / 2,
	animationStartY: ECARD_CANONICAL_HEIGHT / 2,
	animationEndX: ECARD_CANONICAL_WIDTH / 2,
	animationEndY: ECARD_CANONICAL_HEIGHT / 2,
	designCanvasWidth: ECARD_CANONICAL_WIDTH,
	designCanvasHeight: ECARD_CANONICAL_HEIGHT,
};

export const createAnimatedTextLayer = (overrides = {}) => ({
	...DEFAULT_LAYER,
	id: overrides.id || `layer-${Date.now()}`,
	name: overrides.name || DEFAULT_LAYER.name,
	...overrides,
});

const getCanvasFromSource = (source = {}) => {
	const designCanvas = source.designCanvas || {};
	const width = Number(source.designCanvasWidth || designCanvas.width || ECARD_CANONICAL_WIDTH);
	const height = Number(source.designCanvasHeight || designCanvas.height || width || ECARD_CANONICAL_HEIGHT);
	return {
		width: Number.isFinite(width) && width > 0 ? width : ECARD_CANONICAL_WIDTH,
		height: Number.isFinite(height) && height > 0 ? height : ECARD_CANONICAL_HEIGHT,
	};
};

const hasExplicitCanvas = (layer = {}, card = {}) => {
	const designCanvas = card.designCanvas || {};
	return !!(
		layer.designCanvasWidth ||
		layer.designCanvasHeight ||
		card.designCanvasWidth ||
		card.designCanvasHeight ||
		designCanvas.width ||
		designCanvas.height
	);
};

const isLegacyPercentLayer = (layer = {}, card = {}) => {
	if (hasExplicitCanvas(layer, card)) return false;
	const x = Number(layer.x ?? DEFAULT_LAYER.x);
	const y = Number(layer.y ?? DEFAULT_LAYER.y);
	const width = Number(layer.width ?? DEFAULT_LAYER.width);
	return x >= 0 && x <= LEGACY_PERCENT_MAX && y >= 0 && y <= LEGACY_PERCENT_MAX && width > 0 && width <= LEGACY_PERCENT_MAX;
};

const normalizeCanvasValue = (value, sourceSize, targetSize) => {
	const numericValue = Number(value);
	if (!Number.isFinite(numericValue)) return 0;
	return (numericValue / sourceSize) * targetSize;
};

const normalizeLegacyPercent = (value, size) => (Number(value) / LEGACY_PERCENT_MAX) * size;
const normalizeLegacyPx = (value) => Number(value) * LEGACY_TO_CANONICAL_SCALE;

export const normalizeAnimatedTextLayer = (layer = {}, index = 0, card = {}) => {
	const legacyPercentLayer = isLegacyPercentLayer(layer, card);
	const coordinateDefaults = legacyPercentLayer ? LEGACY_DEFAULT_LAYER : DEFAULT_LAYER;
	const sourceCanvas = getCanvasFromSource({ ...card, ...layer });
	const normalizeX = (value) => legacyPercentLayer
		? normalizeLegacyPercent(value, ECARD_CANONICAL_WIDTH)
		: normalizeCanvasValue(value, sourceCanvas.width, ECARD_CANONICAL_WIDTH);
	const normalizeY = (value) => legacyPercentLayer
		? normalizeLegacyPercent(value, ECARD_CANONICAL_HEIGHT)
		: normalizeCanvasValue(value, sourceCanvas.height, ECARD_CANONICAL_HEIGHT);
	const normalizeWidth = (value) => legacyPercentLayer
		? normalizeLegacyPercent(value, ECARD_CANONICAL_WIDTH)
		: normalizeCanvasValue(value, sourceCanvas.width, ECARD_CANONICAL_WIDTH);
	const normalizeSize = (value) => legacyPercentLayer
		? normalizeLegacyPx(value)
		: normalizeCanvasValue(value, sourceCanvas.width, ECARD_CANONICAL_WIDTH);
	const x = normalizeX(layer.x ?? coordinateDefaults.x);
	const y = normalizeY(layer.y ?? coordinateDefaults.y);
	const rawEndTime = Number(layer.endTime ?? DEFAULT_LAYER.endTime);
	const hasExplicitEndFlag = Object.prototype.hasOwnProperty.call(layer, "endTimeEnabled");
	const endTimeEnabled = hasExplicitEndFlag
		? !!layer.endTimeEnabled
		: !(rawEndTime >= 999 || layer.noEndTime === true);

	return {
		...DEFAULT_LAYER,
		...layer,
		id: layer.id || `layer-${index + 1}`,
		name: layer.name || `Text Layer ${index + 1}`,
		text: String(layer.text ?? layer.defaultText ?? DEFAULT_LAYER.text),
		allowUserPersonalization: !!layer.allowUserPersonalization,
		x,
		y,
		width: normalizeWidth(layer.width ?? coordinateDefaults.width),
		fontSize: normalizeSize(layer.fontSize ?? coordinateDefaults.fontSize),
		lineHeight: Number(layer.lineHeight ?? DEFAULT_LAYER.lineHeight),
		letterSpacing: normalizeSize(layer.letterSpacing ?? coordinateDefaults.letterSpacing),
		textShadowBlur: normalizeSize(layer.textShadowBlur ?? coordinateDefaults.textShadowBlur),
		strokeWidth: normalizeSize(layer.strokeWidth ?? coordinateDefaults.strokeWidth),
		startTime: Number(layer.startTime ?? DEFAULT_LAYER.startTime),
		endTime: rawEndTime >= 999 ? DEFAULT_LAYER.endTime : rawEndTime,
		endTimeEnabled,
		entranceAnimation: layer.entranceAnimation || DEFAULT_LAYER.entranceAnimation,
		exitAnimation: layer.exitAnimation || DEFAULT_LAYER.exitAnimation,
		animationPositionEnabled: !!layer.animationPositionEnabled,
		animationDuration: Math.max(0.1, Number(layer.animationDuration ?? DEFAULT_LAYER.animationDuration) || DEFAULT_LAYER.animationDuration),
		animationStartX: normalizeX(layer.animationStartX ?? layer.x ?? coordinateDefaults.animationStartX),
		animationStartY: normalizeY(layer.animationStartY ?? layer.y ?? coordinateDefaults.animationStartY),
		animationEndX: normalizeX(layer.animationEndX ?? layer.x ?? coordinateDefaults.animationEndX),
		animationEndY: normalizeY(layer.animationEndY ?? layer.y ?? coordinateDefaults.animationEndY),
		designCanvasWidth: ECARD_CANONICAL_WIDTH,
		designCanvasHeight: ECARD_CANONICAL_HEIGHT,
	};
};

export const normalizeAnimatedTextLayers = (card = {}) => {
	if (Array.isArray(card.textLayers) && card.textLayers.length > 0) {
		return card.textLayers.map((layer, index) => normalizeAnimatedTextLayer(layer, index, card));
	}

	if (card.textStyle || card.defaultMessage) {
		return [
			normalizeAnimatedTextLayer({
				id: "legacy-layer",
				name: "Text Layer 1",
				text: card.defaultMessage || DEFAULT_LAYER.text,
				allowUserPersonalization: false,
				...(card.textStyle || {}),
			}, 0, card),
		];
	}

	return [];
};

const clamp = (value, min, max) => Math.max(min, Math.min(max, value));
const flattenStyle = (style) => StyleSheet.flatten(style) || {};
const getLayerEndTime = (layer) => layer.endTimeEnabled === false ? Infinity : Number(layer.endTime) || DEFAULT_LAYER.endTime;
const getDisplaySize = (containerSize = {}) => {
	const width = Number(containerSize.width) || 0;
	const height = Number(containerSize.height) || 0;
	if (width && height) return Math.min(width, height);
	return width || height || 0;
};
const getScaleForContainer = (containerSize = {}) => {
	const displaySize = getDisplaySize(containerSize);
	return displaySize > 0 ? displaySize / ECARD_CANONICAL_WIDTH : 1;
};
const getNumericStyleSize = (style = {}) => {
	const width = typeof style.width === "number" ? style.width : 0;
	const height = typeof style.height === "number" ? style.height : 0;
	const maxWidth = typeof style.maxWidth === "number" ? style.maxWidth : 0;
	const maxHeight = typeof style.maxHeight === "number" ? style.maxHeight : 0;
	return getDisplaySize({ width: width || maxWidth, height: height || maxHeight });
};
const toDisplayPx = (value, scale) => Number(value || 0) * scale;

const getLayerRestingPosition = (layer) => ({
	x: layer.animationPositionEnabled ? Number(layer.animationEndX ?? layer.x) : Number(layer.x),
	y: layer.animationPositionEnabled ? Number(layer.animationEndY ?? layer.y) : Number(layer.y),
});

const getLayerText = (layer, layerTextValues = {}) => {
	const value = layerTextValues[layer.id];
	return value === undefined || value === null ? layer.text : value;
};

const getAnimationState = (layer, currentTime, containerSize = { width: 0, height: 0 }, scale = 1) => {
	const entranceDuration = DEFAULT_ANIMATION_DURATION;
	const exitDuration = 0.45;
	const startTime = Number(layer.startTime) || 0;
	const motionDuration = Math.max(0.1, Number(layer.animationDuration) || DEFAULT_ANIMATION_DURATION);
	const endTime = getLayerEndTime(layer);
	const timeSinceStart = currentTime - startTime;
	const timeUntilEnd = endTime - currentTime;
	const entering = timeSinceStart < entranceDuration;
	const exiting = Number.isFinite(endTime) && timeUntilEnd < exitDuration;
	const progress = entering
		? clamp(timeSinceStart / entranceDuration, 0, 1)
		: exiting
			? clamp(timeUntilEnd / exitDuration, 0, 1)
			: 1;
	const animation = entering ? layer.entranceAnimation : exiting ? layer.exitAnimation : "none";

	let opacity = 1;
	const transforms = [];
	let reveal = 1;

	if (layer.animationPositionEnabled && timeSinceStart < motionDuration && getDisplaySize(containerSize)) {
		const motionProgress = clamp(timeSinceStart / motionDuration, 0, 1);
		const endX = Number(layer.animationEndX ?? layer.x);
		const endY = Number(layer.animationEndY ?? layer.y);
		const startX = Number(layer.animationStartX ?? endX);
		const startY = Number(layer.animationStartY ?? endY);
		const currentX = startX + (endX - startX) * motionProgress;
		const currentY = startY + (endY - startY) * motionProgress;
		const dx = toDisplayPx(currentX - endX, scale);
		const dy = toDisplayPx(currentY - endY, scale);
		transforms.push(`translate(${dx}px, ${dy}px)`);
	}

	if (animation === "fade") opacity = progress;
	if (animation === "fade-scale") {
		opacity = progress;
		transforms.push(`scale(${0.92 + progress * 0.08})`);
	}
	if (animation === "slide-up") {
		opacity = progress;
		transforms.push(`translateY(${toDisplayPx(DEFAULT_SLIDE_Y_DISTANCE * (1 - progress), scale)}px)`);
	}
	if (animation === "slide-down") {
		opacity = progress;
		transforms.push(`translateY(${toDisplayPx(DEFAULT_SLIDE_Y_DISTANCE * (progress - 1), scale)}px)`);
	}
	if (animation === "slide-left") {
		opacity = progress;
		transforms.push(`translateX(${toDisplayPx(DEFAULT_SLIDE_X_DISTANCE * (1 - progress), scale)}px)`);
	}
	if (animation === "slide-right") {
		opacity = progress;
		transforms.push(`translateX(${toDisplayPx(DEFAULT_SLIDE_X_DISTANCE * (progress - 1), scale)}px)`);
	}
	if (animation === "pop") {
		opacity = progress;
		const scale = progress < 0.78 ? 0.7 + progress * 0.45 : 1;
		transforms.push(`scale(${scale})`);
	}
	if (animation === "bounce") {
		opacity = progress;
		const bounce = toDisplayPx(Math.sin(progress * Math.PI) * DEFAULT_BOUNCE_DISTANCE, scale);
		transforms.push(`translateY(${-bounce}px)`);
	}
	if (animation === "type") {
		opacity = 1;
		reveal = progress;
	}

	return { opacity, transform: transforms.length ? transforms.join(" ") : "none", reveal };
};

const getLayerBoxStyle = (layer, selected, currentTime, editable, scale) => {
	const position = getLayerRestingPosition(layer);
	const left = clamp(position.x - layer.width / 2, 0, ECARD_CANONICAL_WIDTH - layer.width);

	return {
		position: "absolute",
		left: `${toDisplayPx(left, scale)}px`,
		top: `${toDisplayPx(position.y, scale)}px`,
		width: `${toDisplayPx(layer.width, scale)}px`,
		transform: "none",
		opacity: 0,
		visibility: "hidden",
		willChange: "opacity, transform",
		transformOrigin: "center center",
		cursor: editable ? "grab" : "default",
		outline: selected ? "1px dashed rgba(255, 255, 255, 0.92)" : "0 solid transparent",
		borderRadius: toDisplayPx(6, scale),
		boxSizing: "border-box",
		pointerEvents: editable ? "auto" : "none",
	};
};

const getLayerTextStyle = (layer, textScale, reveal) => {
	const scaledStrokeWidth = Math.max(0, toDisplayPx(layer.strokeWidth, textScale));
	const scaledShadowBlur = Math.max(0, toDisplayPx(layer.textShadowBlur, textScale));
	const scaledShadowOffsetY = toDisplayPx(DEFAULT_TEXT_SHADOW_OFFSET_Y, textScale);

	return {
		display: "block",
		overflow: "hidden",
		maxWidth: `${reveal * 100}%`,
		clipPath: `inset(0 ${100 - reveal * 100}% 0 0)`,
		whiteSpace: "pre-wrap",
		color: layer.color,
		WebkitTextFillColor: layer.color,
		fontFamily: getFontFamilyCss(layer.fontFamily),
		fontSize: `${Math.max(1, toDisplayPx(layer.fontSize, textScale))}px`,
		fontWeight: String(layer.fontWeight || "700"),
		textAlign: layer.textAlign,
		lineHeight: layer.lineHeight,
		letterSpacing: `${toDisplayPx(layer.letterSpacing, textScale)}px`,
		textShadow: layer.textShadowEnabled ? `0 ${scaledShadowOffsetY}px ${scaledShadowBlur}px ${layer.textShadowColor}` : "none",
		WebkitTextStroke: scaledStrokeWidth > 0 ? `${scaledStrokeWidth}px ${layer.strokeColor}` : "0 transparent",
		textStroke: scaledStrokeWidth > 0 ? `${scaledStrokeWidth}px ${layer.strokeColor}` : "0 transparent",
		paintOrder: "stroke fill",
	};
};

const isLayerActive = (layer, currentTime) => {
	const startTime = Number(layer.startTime) || 0;
	const endTime = getLayerEndTime(layer);
	return currentTime >= startTime && currentTime <= endTime;
};

const AnimatedAsset = ({ card, assetStyle, muted, mediaRef, controls = false, autoPlay = true, loop = true }) => {
	const isGif = isGifECardMedia(card);
	const assetUrl = getECardPlaybackAssetUrl(card);
	const mediaStyle = {
		display: "block",
		position: "absolute",
		inset: 0,
		width: "100%",
		height: "100%",
		maxWidth: "100%",
		maxHeight: "100%",
		objectFit: assetStyle.objectFit || "cover",
		borderRadius: assetStyle.borderRadius || 0,
	};

	if (isGif) {
		return React.createElement("img", {
			ref: mediaRef,
			"data-ecard-media": "true",
			src: assetUrl,
			alt: card.title || "Animated eCard",
			style: mediaStyle,
		});
	}

	return React.createElement("video", {
		ref: mediaRef,
		"data-ecard-media": "true",
		src: assetUrl,
		style: mediaStyle,
		autoPlay,
		loop,
		muted,
		playsInline: true,
		controls,
	});
};

const AnimatedECardPreview = ({
	card,
	style,
	assetStyle,
	muted = true,
	controls = false,
	autoPlay = true,
	loop = true,
	layerTextValues = {},
	editable = false,
	selectedLayerId,
	onSelectLayer,
	onLayerPositionChange,
}) => {
	const dragRef = useRef(null);
	const mediaRef = useRef(null);
	const wrapperRef = useRef(null);
	const layerRefs = useRef({});
	const textRefs = useRef({});
	const wrapperStyle = flattenStyle(style);
	const mediaStyle = flattenStyle(assetStyle);
	const layers = useMemo(() => normalizeAnimatedTextLayers(card), [card]);
	const isGif = isGifECardMedia(card);
	const [measuredSize, setMeasuredSize] = useState({ width: 0, height: 0 });
	const fallbackDisplaySize = getNumericStyleSize(wrapperStyle);
	const previewScale = getDisplaySize(measuredSize) > 0
		? getScaleForContainer(measuredSize)
		: (fallbackDisplaySize > 0 ? fallbackDisplaySize / ECARD_CANONICAL_WIDTH : 1);

	useEffect(() => {
		layers.forEach((layer) => ensureGoogleFontLoaded(layer.fontFamily));
	}, [layers]);

	useEffect(() => {
		if (Platform.OS !== "web") return undefined;
		const wrapperNode = wrapperRef.current;
		if (!wrapperNode) return undefined;
		const updateMeasuredSize = () => {
			const rect = wrapperNode.getBoundingClientRect?.();
			const nextSize = {
				width: rect?.width || wrapperNode.clientWidth || 0,
				height: rect?.height || wrapperNode.clientHeight || 0,
			};
			setMeasuredSize((currentSize) => (
				Math.abs(currentSize.width - nextSize.width) > 0.5 ||
				Math.abs(currentSize.height - nextSize.height) > 0.5
					? nextSize
					: currentSize
			));
		};

		updateMeasuredSize();

		if (typeof ResizeObserver === "undefined") {
			window.addEventListener("resize", updateMeasuredSize);
			return () => window.removeEventListener("resize", updateMeasuredSize);
		}

		const observer = new ResizeObserver(updateMeasuredSize);
		observer.observe(wrapperNode);
		return () => observer.disconnect();
	}, []);

	useEffect(() => {
		if (Platform.OS !== "web") return undefined;
		const startedAt = Date.now();
		const finiteEndTimes = layers.map((layer) => layer.endTimeEnabled === false ? 0 : Number(layer.endTime) || 0).filter((time) => time > 0);
		const latestStartTime = Math.max(0, ...layers.map((layer) => Number(layer.startTime) || 0));
		const latestMotionEndTime = Math.max(0, ...layers.map((layer) => {
			const startTime = Number(layer.startTime) || 0;
			const motionDuration = Math.max(0.1, Number(layer.animationDuration) || DEFAULT_ANIMATION_DURATION);
			return startTime + motionDuration;
		}));
		const timelineDuration = finiteEndTimes.length
			? Math.max(1, ...finiteEndTimes)
			: Math.max(8, latestStartTime + 4, latestMotionEndTime + 1);
		let animationFrameId = null;

		const updateLayers = () => {
			const mediaNode = mediaRef.current;
			const wrapperRect = wrapperRef.current?.getBoundingClientRect?.();
			const containerSize = {
				width: wrapperRect?.width || 0,
				height: wrapperRect?.height || 0,
			};
			const currentTime = isGif
				? ((Date.now() - startedAt) / 1000) % timelineDuration
				: Number(mediaNode?.currentTime || 0);

			layers.forEach((layer) => {
				const layerNode = layerRefs.current[layer.id];
				const textNode = textRefs.current[layer.id];
				if (!layerNode || !textNode) return;

				if (!isLayerActive(layer, currentTime)) {
					layerNode.style.opacity = "0";
					layerNode.style.visibility = "hidden";
					layerNode.style.transform = "none";
					textNode.style.clipPath = "inset(0 0 0 0)";
					return;
				}

				const animationScale = getScaleForContainer(containerSize);
				const animationState = getAnimationState(layer, currentTime, containerSize, animationScale);
				layerNode.style.opacity = String(animationState.opacity);
				layerNode.style.visibility = "visible";
				layerNode.style.transform = animationState.transform;
				textNode.style.clipPath = `inset(0 ${100 - animationState.reveal * 100}% 0 0)`;
			});

			animationFrameId = requestAnimationFrame(updateLayers);
		};

		animationFrameId = requestAnimationFrame(updateLayers);

		return () => {
			if (animationFrameId) cancelAnimationFrame(animationFrameId);
		};
	}, [isGif, layers]);

	if (Platform.OS !== "web") {
		return (
			<View style={[styles.nativeWrapper, style]}>
				<Text style={styles.nativeFallbackText}>Animated eCard</Text>
			</View>
		);
	}

	const handlePointerMove = (event) => {
		if (!dragRef.current || !onLayerPositionChange) return;
		const rect = event.currentTarget.getBoundingClientRect();
		const displaySize = getDisplaySize({ width: rect.width, height: rect.height }) || rect.width || 1;
		const canvasLeft = rect.left + (rect.width - displaySize) / 2;
		const canvasTop = rect.top + (rect.height - displaySize) / 2;
		const x = clamp(((event.clientX - canvasLeft) / displaySize) * ECARD_CANONICAL_WIDTH, 0, ECARD_CANONICAL_WIDTH);
		const y = clamp(((event.clientY - canvasTop) / displaySize) * ECARD_CANONICAL_HEIGHT, 0, ECARD_CANONICAL_HEIGHT);
		onLayerPositionChange(dragRef.current, { x: Math.round(x), y: Math.round(y) });
	};

	const stopDrag = () => {
		dragRef.current = null;
	};

	return React.createElement(
		"div",
		{
			ref: wrapperRef,
			"data-ecard-render-target": "true",
			style: {
				...wrapperStyle,
				position: "relative",
				overflow: "hidden",
				backgroundColor: wrapperStyle.backgroundColor || "#111827",
				display: wrapperStyle.display || "block",
				maxWidth: wrapperStyle.maxWidth || "100%",
				width: wrapperStyle.width || "100%",
				aspectRatio: wrapperStyle.aspectRatio || 1,
				lineHeight: 0,
			},
			onPointerMove: handlePointerMove,
			onPointerUp: stopDrag,
			onPointerLeave: stopDrag,
		},
		[
			React.createElement(AnimatedAsset, {
				key: "asset",
				card,
				assetStyle: { ...wrapperStyle, ...mediaStyle },
				muted,
				mediaRef,
				controls,
				autoPlay,
				loop,
			}),
			...layers
				.map((layer) => {
					const selected = selectedLayerId === layer.id;
					return React.createElement(
						"div",
						{
							key: layer.id,
							ref: (node) => {
								if (node) layerRefs.current[layer.id] = node;
								else delete layerRefs.current[layer.id];
							},
							style: getLayerBoxStyle(layer, selected, 0, editable, previewScale),
							onPointerDown: (event) => {
								if (!editable) return;
								event.preventDefault();
								event.stopPropagation();
								dragRef.current = layer.id;
								onSelectLayer?.(layer.id);
							},
							onClick: (event) => {
								if (!editable) return;
								event.stopPropagation();
								onSelectLayer?.(layer.id);
							},
						},
						React.createElement(
							"span",
							{
								ref: (node) => {
									if (node) textRefs.current[layer.id] = node;
									else delete textRefs.current[layer.id];
								},
								"data-ecard-layer-id": layer.id,
								"data-ecard-layer-text": getLayerText(layer, layerTextValues),
								style: getLayerTextStyle(layer, previewScale, 1),
							},
							getLayerText(layer, layerTextValues)
						)
					);
				}),
		]
	);
};

const styles = StyleSheet.create({
	nativeWrapper: {
		alignItems: "center",
		justifyContent: "center",
		backgroundColor: "#111827",
	},
	nativeFallbackText: {
		color: "#ffffff",
		fontSize: 12,
		fontWeight: "700",
	},
});

export default AnimatedECardPreview;
